import SpecialtyEntity from '../entities/Specialty.Entity';
import { apiGet } from '../support/helpers/ApiConnection.Helper';

export default function getSpecialties(abortSignal: AbortSignal): Promise<Array<SpecialtyEntity>> {    
    return apiGet<Array<SpecialtyEntity>>('/specialties',abortSignal);
}
